// Copyright (c) Microsoft Corporation.
// Licensed under the MIT license.

import _ from "lodash";
import React, { RefObject } from "react";
import { connect } from "react-redux";
//import { RouteComponentProps } from "react-router-dom";
import { RouteComponentProps, Link } from "react-router-dom";
import SplitPane from "react-split-pane";
import { bindActionCreators } from "redux";
import { PrimaryButton } from "@fluentui/react";
import HtmlFileReader from "../../../../../common/htmlFileReader";
import { strings, interpolate } from "../../../../../common/strings";
import {
    AssetState, AssetType, EditorMode, FieldType,
    IApplicationState, IAppSettings, IAsset, IAssetMetadata,
    ILabel, IProject, IRegion, ISize, ITag, FeatureCategory, FieldFormat,
    IAuthenticationState,IPrebuiltSettings,ErrorCode,IAzureFields
} from "../../../../../models/applicationState";
import IApplicationActions, * as applicationActions from "../../../../../redux/actions/applicationActions";
import IProjectActions, * as projectActions from "../../../../../redux/actions/projectActions";
import IAppTitleActions, * as appTitleActions from "../../../../../redux/actions/appTitleActions";
import { AssetPreview, ContentSource } from "../../../common/assetPreviewFR/assetPreview";
import { KeyboardBinding } from "../../../common/keyboardBinding/keyboardBinding";
import { KeyEventType } from "../../../common/keyboardManager/keyboardManager";
import { TagInput } from "../../../common/tagInputFR/tagInput";
import { tagIndexKeys } from "../../../common/tagInputFR/tagIndexKeys";
import Canvas from "./canvas";
import { TableView } from "./tableView"
import CanvasHelpers from "./canvasHelpers";
import "./editorPage.scss";
import EditorSideBar from "./editorSideBar";
import Alert from "../../../common/alert/alert";
import Confirm from "../../../common/confirm/confirm";
import { OCRService } from "../../../../../services/ocrService";
import { throttle } from "../../../../../common/utils";
import { constants } from "../../../../../common/constants";
import PreventLeaving from "../../../common/preventLeaving/preventLeaving";
import { Spinner, SpinnerSize } from "@fluentui/react/lib/Spinner";
import { getPrimaryGreenTheme, getPrimaryRedTheme } from "../../../../../common/themes";
import { toast } from "react-toastify";
import { PredictService } from "../../../../../services/PredictService";
import { AssetService } from "../../../../../services/assetService";
import BeforeUnloadComponent from "react-beforeunload-component";
import { SkipButton } from "../../../shell/skipButton";
import ModalHeader from "../../header/subHeader";
import ODModalHeader from "../../header/ODsubHeader";
import HeaderComponent from "../../header/header";
import size from "lodash/size";
import { StatusBar } from "../../../shell/statusBar";
import { StatusBarMetrics } from "../../../shell/statusBarMetrics";
import PrebuiltsubHeader from "../../header/prebuiltsubheader";
import {getPrimaryWhiteTheme} from "../../../../../common/themes";
import {ILoadFileHelper, ILoadFileResult, LoadFileHelper} from "./LoadFileHelper";
import {ITableHelper, ITableState, TableHelper} from "./tableHelper";
import url from "url";
import ServiceHelper from "../../../../../services/serviceHelper";
import {Feature} from "ol";
import Polygon from "ol/geom/Polygon";
import Fill from "ol/style/Fill";
import Stroke from "ol/style/Stroke";
import Style from "ol/style/Style";
import {ImageMap} from "../../../common/imageMapNew/imageMap";
import {poll,loadImageToCanvas,parseTiffData, renderTiffToCanvas} from "../../../../../common/utils";
import PredictResult from "../predict/predictResult";

import LoadingOverlay from "react-loading-overlay";

import {PrebuiltSetting} from "../../../common/prebuiltSetting/prebuiltSetting";
import IAppPrebuiltSettingsActions, * as appPrebuiltSettingsActions from "../../../../../redux/actions/prebuiltSettingsActions";
import * as pdfjsLib from "pdfjs-dist";
import "../predict/predictPage.scss";
 
import "./prebuiltPredictPage.scss";
import {
    Dropdown, FontIcon, IconButton, IDropdownOption,
    ITooltipHostStyles,     
    Separator,
    //Spinner, SpinnerSize, 
    TooltipHost
} from "@fluentui/react";

import {CanvasCommandBar} from "../editorPage/canvasCommandBar";

import axios from "axios";

//import { runAnalysisPrebuiltInvoice } from "../../../../../common/api-config";

import { documentPredictionEndPoint, deleteBlobEndPoint,runAnalysisPrebuiltInvoice,getPredictionResult_invoice
    ,accessTokenData, accessToken, refreshTokenEndPoint, refreshTokenCall } from '../../../../../common/api-config';

import JsonResponse from "./jsonResponse";
import JsonViewResponse from "./JsonViewResponse";

pdfjsLib.GlobalWorkerOptions.workerSrc = constants.pdfjsWorkerSrc(pdfjsLib.version);
const cMapUrl = constants.pdfjsCMapUrl(pdfjsLib.version);

interface IPrebuiltTypes {
    name: string;
    servicePath: string;
    useLocale?: boolean;
}

/**
 * Properties for Editor Page
 * @member project - Project being edited
 * @member recentProjects - Array of projects recently viewed/edited
 * @member actions - Project actions
 * @member applicationActions - Application setting actions
 */
export interface IEditorPageProps extends RouteComponentProps, React.Props<PEditorPageOCR> {
    project: IProject;
    recentProjects: IProject[];
    appSettings: IAppSettings;
    actions: IProjectActions;
    //actions:IAppPrebuiltSettingsActions;
    applicationActions: IApplicationActions;
    appTitleActions: IAppTitleActions;
    loggedInUser: IAuthenticationState;
    loadAnnotateFiles: IAsset[];

    prebuiltSettings: IPrebuiltSettings;
    //appTitleActions: IAppTitleActions;
   // actions: IAppPrebuiltSettingsActions;
}

/**
 * State for Editor Page
 */
export interface IEditorPageState  extends ILoadFileResult, ITableState {
    /** Array of assets in project */
    assets: IAsset[];
    /** The editor mode to set for canvas tools */
    editorMode: EditorMode;
    /** The selected asset for the primary editing experience */
    selectedAsset?: IAssetMetadata;
    /** Currently selected region on current asset */
    selectedRegions?: IRegion[];
    /** Most recently selected tag */
    selectedTag: string;
    /** Tags locked for region labeling */
    lockedTags: string[];
    /** Size of the asset thumbnails to display in the side bar */
    thumbnailSize: ISize;
    /**
     * Whether or not the editor is in a valid state
     * State is invalid when a region has not been tagged
     */
    isValid: boolean;
    /** Whether the show invalid region warning alert should display */
    showInvalidRegionWarning: boolean;
    /** Show tags when loaded */
    tagsLoaded: boolean;
    /** The currently hovered TagInputItemLabel */
    hoveredLabel: ILabel;
    /** Whether the task for loading all OCRs is running */
    isRunningOCRs?: boolean;
    /** Whether OCR is running in the main canvas */
    isCanvasRunningOCR?: boolean;
    isCanvasRunningAutoLabeling?: boolean;
    isError?: boolean;
    errorTitle?: string;
    errorMessage?: string;
    tableToView: object;
    tableToViewId: string;
    selectedOcrFile: any;

    userId: string;

    //new 
    fileLabel: string;
    fileChanged: boolean;
    file?: File;
    isFetching?: boolean;
    fileLoaded?: boolean;

    isPredicting: boolean;
    predictionLoaded: boolean;
    fetchedFileURL: string;
    analyzeResult: any;

    tags?: ITag[];
    highlightedField?: string;
    imageAngle: number;
    currentPrebuiltType: IPrebuiltTypes;
    currentLocale: string;

    withPageRange: boolean;
    pageRange: string;
    pageRangeIsValid?: boolean;

    imageUri: any;
    imageWidth:number;
    imageHeight: number;
    currentPage: number;
    numPages:number;
    shouldShowAlert:boolean;
    alertTitle: string;
    alertMessage: string; 
    tableIconTooltip: any;
    hoveringFeature:any;
   // prebuiltSettings:any;
   features:any[];

   tiffImages: any[];
   pdfFile: any;
   analyseDataLoad: boolean;
   outPutFormat: string;
   displayOverlay:boolean;
   analyzeFullResult: any;

}

function mapStateToProps(state: IApplicationState) {
    return {
        recentProjects: state.recentProjects,
        project: state.currentProject,
        appSettings: state.appSettings,
        loggedInUser: state.loggedInUser,
        loadAnnotateFiles: state.loadAllFiles,
        prebuiltSettings: state.prebuiltSettings,
    };
}

function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(projectActions, dispatch),
        applicationActions: bindActionCreators(applicationActions, dispatch),
        appTitleActions: bindActionCreators(appTitleActions, dispatch),
    };
}

/**
 * @name - Editor Page
 * @description - Page for adding/editing/removing tags to assets
 */
@connect(mapStateToProps, mapDispatchToProps)
export default class PEditorPageOCR extends React.Component<IEditorPageProps, IEditorPageState> {
    
    private appInsights: any = null;
    prebuiltTypes: IPrebuiltTypes[] = [
        {
            name: "Invoice",
            servicePath: "/prebuilt/invoice/analyze"
        },
        {
            name: "Receipt",
            servicePath: "/prebuilt/receipt/analyze",
            useLocale: true,
        },
        {
            name: "Business card",
            servicePath: "/prebuilt/businessCard/analyze",
            useLocale: true,
        },
        {
            name: "ID",
            servicePath: "/prebuilt/idDocument/analyze"
        }
    ];
    public state: IEditorPageState = {
        selectedTag: null,
        lockedTags: [],
        assets: [],
        editorMode: EditorMode.Select,
        thumbnailSize: { width: 175, height: 155 },
        isValid: true,
        showInvalidRegionWarning: false,
        tagsLoaded: false,
        hoveredLabel: null,
        tableToView: null,
        tableToViewId: null,
        selectedOcrFile: null,

        userId: null,

        imageUri: null,
       // imageWidth: 0,
       // imageHeight: 0,
       imageWidth: 1024,
       imageHeight: 768,
        currentPage: 1,
        numPages: 1,

        shouldShowAlert: false,
        alertTitle: "",
        alertMessage: "",

        fileLabel: "",
        fileChanged: false,

        isPredicting: false,
        predictionLoaded: false,
        fetchedFileURL: "",
        analyzeResult: null,

        imageAngle: 0,
        currentPrebuiltType: this.prebuiltTypes[0],

        tableIconTooltip: {display: "none", width: 0, height: 0, top: 0, left: 0},
        hoveringFeature: null,
        //tableToView: null,
       // tableToViewId: null,
        currentLocale: "en-US",

        withPageRange: false,
        pageRange: "",
      //  prebuiltSettings:null,
      features:null,
      tiffImages:[],
      pdfFile: null,
      analyseDataLoad: false,
      outPutFormat: "",
      displayOverlay:false,
      analyzeFullResult:null,
    };

    private tagInputRef: RefObject<TagInput>;

    private loadingProjectAssets: boolean = false;
    private canvas: RefObject<Canvas> = React.createRef();
    private renameTagConfirm: React.RefObject<Confirm> = React.createRef();
    private renameCanceled: () => void;
    private deleteTagConfirm: React.RefObject<Confirm> = React.createRef();
    private deleteDocumentConfirm: React.RefObject<Confirm> = React.createRef();
    private isUnmount: boolean = false;

    private analyzeResults: any;
    private fileHelper: ILoadFileHelper = new LoadFileHelper();

    private tableHelper: ITableHelper = new TableHelper(this);

    private imageMap: ImageMap;
    private tagColors = require("../../../common/tagColors.json");


    constructor(props) {
        super(props);
        this.tagInputRef = React.createRef();
    }

    public async componentDidMount() {
        window.addEventListener("focus", this.onFocused);

        this.isUnmount = false;
        const projectId = this.props.match.params["projectId"];
        const projectName = this.props.match.params["projectName"];
        const user = this.props.loggedInUser;
        const userId = user.user.oid;
        this.setState({ userId });

        if (this.props.project) {
            await this.loadProjectAssets();
            this.props.appTitleActions.setTitle(this.props.project.name);
        } else if (projectId) {
            const project = this.props.recentProjects.find((project) => project.id === projectId);
            await this.props.actions.loadProject(project);
            this.props.appTitleActions.setTitle(project.name);

            //
           // const projectCopy = await Object.assign({}, recentProject);
           project.folderPath = `${projectName}-${userId}/training`;
           project.tags = project.tags;
            await this.props.actions.saveProject(project, false, false);
            await this.props.actions.loadProject(project);
            await this.props.actions.updateProjectTagsFromFiles(this.props.project);
            this.setState({ tagsLoaded: true });
            //


        }
        this.getFilesFromBlob();
        document.title = strings.editorPage.title + " - " + strings.appName;
    }

    public getFilesFromBlob = () => {
        const projectCopy = Object.assign({}, this.props.project);
        projectCopy.folderPath = `${this.props.match.params["projectName"]}-${this.state.userId}/training`;
        this.props.actions.loadBlobs(projectCopy, "invtraining");
    }


    public async componentDidUpdate(prevProps: Readonly<IEditorPageProps>,prevState) {
        if (this.props.project) {
            if (this.state.assets.length === 0) {
                await this.loadProjectAssets();
            } else {
                this.updateAssetsState();
            }
        }
        const { project } = this.props;
        //
      /*  if (project && prevProps.project && project.tags !== prevProps.project.tags) {
            this.updateRootAssets();
        }
        if (prevProps.uploadFilesCount && prevProps.uploadFilesCount !== prevState.uploadFilesCount) {
            prevState.uploadFilesCount = prevProps.uploadFilesCount;
            this.getFilesFromBlob();
        }*/
        if (this.props.loadAnnotateFiles !== prevProps.loadAnnotateFiles) {
            await this.loadProjectAssets();
        } else {
            localStorage.setItem("filesLengthFromModel", prevProps.loadAnnotateFiles.length.toString())
        }
        //

        //
        if (this.state.imageUri) {
            //  debugger;
              if (this.state.fileChanged && !this.state.isFetching) {
                //  this.loadFile(this.state.file);
                this.loadImage();
                  this.analyzeResults = undefined;
              } else if (prevState.currentPage !== this.state.currentPage) {
                  this.fileHelper.loadPage(this.state.currentPage).then((res: any) => {
                      if (res) {
                          this.setState({...res});
                      }
                  });
              }
  
              if (this.getOcrFromAnalyzeResult(this.state.analyzeResult).length > 0 &&
                  prevState.imageUri !== this.state.imageUri) {
                  this.imageMap.removeAllFeatures();
                  this.drawPredictionResult();
  
              }
  
              if (prevState.highlightedField !== this.state.highlightedField) {
                  this.setPredictedFieldHighlightStatus(this.state.highlightedField);
              }
          }
        //
    }

    public componentWillUnmount() {
        this.isUnmount = true;
        window.removeEventListener("focus", this.onFocused);
        this.abortController.abort();
    }

    
    getPredictDisabled = (): boolean => {
        return this.state.isPredicting || !this.state.imageUri
            || this.state.invalidFileFormat ||
            !this.state.fileLoaded ||
            !this.props.prebuiltSettings?.apiKey ||
            !this.props.prebuiltSettings?.serviceURI ||
            (this.state.withPageRange && !this.state.pageRangeIsValid);
    }
    
    //componentWillUnmount = () => this.abortController.abort();

  abortController = new window.AbortController();

    public render() {
      //  debugger;
        const { project } = this.props;
        const { assets, selectedAsset, isRunningOCRs, isCanvasRunningOCR, isCanvasRunningAutoLabeling ,  analyzeFullResult} = this.state;

        const labels = (selectedAsset &&
            selectedAsset.labelData &&
            selectedAsset.labelData.labels) || [];

        const needRunOCRButton = assets.some((asset) => asset.state === AssetState.NotVisited);

        if (!project) {
            return (<div className="text-center mt-5">Loading...</div>);
        }

        
        //const { selectedOcrFile} = this.state;
        // const showTable = size(columnNames) > 0 ? true : false;
        const routeUrl = `/upload-files/${this.props.match.params["projectName"]}/${this.props.match.params["schema"]}/ocr/${this.props.match.params["projectId"]}`;
        
        const predictDisabled: boolean = false;// this.getPredictDisabled();

        const predictions = this.getPredictionsFromAnalyzeResult(this.state.analyzeResult);

       // const onPrebuiltsPath: boolean = this.props.match.path.includes("prebuilts");

        const onPrebuiltsPath: boolean =  true;

        return (

            <>
            <HeaderComponent
               history={this.props.history}
               match={this.props.match}
               location={this.props.location} />
               
               <PrebuiltsubHeader
                   history={this.props.history}
                   match={this.props.match}
                   actions={this.props.actions}
                   location={this.props.location}
                   project={this.props.project} />
            <div className="editor-page skipToMainContent" id="pageEditor">

          
            <BeforeUnloadComponent
                        alertMessage='Are you sure you want to leave? Changes will not be saved.'
                    >
               
                {this.state.tableToView !== null &&
                    <TableView
                        handleTableViewClose={this.handleTableViewClose}
                        tableToView={this.state.tableToView}
                    />
                }
                {
                    tagIndexKeys.map((index) =>
                        (<KeyboardBinding
                            displayName={strings.editorPage.tags.hotKey.apply}
                            key={index}
                            keyEventType={KeyEventType.KeyDown}
                            accelerators={[`${index}`]}
                            icon={"fa-tag"}
                            handler={this.handleTagHotKey} />))
                }
                <SplitPane split="vertical"
                    defaultSize={this.state.thumbnailSize.width}
                    minSize={150}
                    maxSize={325}
                    paneStyle={{ display: "flex" }}
                    onChange={this.onSideBarResize}
                    onDragFinished={this.onSideBarResizeComplete}>
                    <div className="editor-page-sidebar bg-lighter-1">
                       
                       {/*
                       
                        {needRunOCRButton && <div>
                            <PrimaryButton
                                theme={getPrimaryGreenTheme()}
                                className="editor-page-sidebar-run-ocr"
                                type="button"
                                onClick={() => this.loadOcrForNotVisited()}
                                disabled={this.isBusy()}>
                                {this.state.isRunningOCRs ?
                                    <div>
                                        <Spinner
                                            size={SpinnerSize.small}
                                            label="Running OCR"
                                            ariaLive="off"
                                            labelPosition="right"
                                        />
                                    </div> : "Run OCR on unvisited documents"
                                }
                            </PrimaryButton>
                        </div>}
                            */}

<>
                            <table cellSpacing="0" cellPadding="0">
                                <tbody>
                                <tr>
                                    <td className="text-center" >
                                        <Link to={routeUrl}
                                            type="button" className="ul-more">
                                            <i className="fa fa fa-upload" aria-hidden="true"></i> Upload
                                </Link>
                                    </td>
                                    {needRunOCRButton && <td className="text-center" >
                                        <PrimaryButton
                                            theme={getPrimaryGreenTheme()}
                                            className="run-all"
                                            type="button"
                                            onClick={() => this.loadOcrForNotVisited()}
                                            disabled={this.state.isRunningOCRs}>
                                            {this.state.isRunningOCRs ?
                                                <div>
                                                    <Spinner
                                                        size={SpinnerSize.small}
                                                        label="Running OCR"
                                                        ariaLive="off"
                                                        labelPosition="right"
                                                    />
                                                </div> : "Run OCR on all"
                                            }
                                        </PrimaryButton>

                                    </td>
                                    }
                                </tr>
                                </tbody>
                            </table>
                            </>

                            {size(assets) !== 0 ?

                          
                        <EditorSideBar
                            assets={assets}
                            selectedAsset={selectedAsset ? selectedAsset.asset : null}
                            onBeforeAssetSelected={this.onBeforeAssetSelected}
                            onAssetSelected={this.selectAsset}
                            onAssetLoaded={this.onAssetLoaded}
                            thumbnailSize={this.state.thumbnailSize}
                        />
                        : <Spinner
                        size={SpinnerSize.small}
                        label="Loading Files"
                        ariaLive="off"
                        labelPosition="bottom"
                    />
                   }
                    </div>

                    <div
                className={`editor-page skipToMainContent ${onPrebuiltsPath ? "" : "hidden"} `}
                id="pagePredict"
                style={{display: `${onPrebuiltsPath ? "flex" : "none"}`}} >
                <div className="predict-main">
                    { this.state.imageUri && this.renderImageMap()}
                    {this.renderPrevPageButton()}
                    {this.renderNextPageButton()}
                    {this.renderPageIndicator()}
                </div>
                <div className="predict-sidebar bg-lighter-1">
                <div className="condensed-list">
                        <h6 className="condensed-list-header bg-darker-2 p-2 flex-center">
                            <FontIcon className="mr-1" iconName="ContactCard" />
                            <span>{interpolate(strings.prebuiltPredict.anlayWithPrebuiltModels, this.state.currentPrebuiltType)}</span>
                        </h6>
                        {
/*
                        <PrebuiltSetting prebuiltSettings={this.props.prebuiltSettings}
                            disabled={this.state.isPredicting}
                            actions={this.props.actions}
                        />
                        
                        <div className="p-3" style={{marginTop: "-3rem"}}>
                            <div className="formtype-section">
                                <div style={{marginBottom: "3px"}}>{strings.prebuiltPredict.formTypeTitle}</div>
                                <Dropdown
                                    disabled={this.state.isPredicting}
                                    className="prebuilt-type-dropdown"
                                    options={this.prebuiltTypes.map(type => ({key: type.name, text: type.name}))}
                                    defaultSelectedKey={this.state.currentPrebuiltType.name}
                                    onChange={this.onPrebuiltTypeChange}></Dropdown>
                            </div>
                            <div className="locales-section" style={{display: this.state.currentPrebuiltType.useLocale ? "block" : "none"}}>
                                <div style={{marginBottom: "3px"}}>{strings.prebuiltPredict.locale}</div>
                                <Dropdown
                                    disabled={this.state.isPredicting}
                                    className="prebuilt-type-dropdown"
                                    options={this.locales.map(type => ({key: type, text: type}))}
                                    defaultSelectedKey={this.state.currentLocale}
                                    onChange={this.onLocaleChange}></Dropdown>
                            </div>
                        </div>
                        <div className="p-3" style={{marginTop: "8px"}}>
                            <h5>{strings.prebuiltPredict.selectFileAndRunAnalysis}</h5>
                            <DocumentFilePicker
                                disabled={this.state.isPredicting || this.state.isFetching}
                                onFileChange={(data) => this.onFileChange(data)}
                                onSelectSourceChange={() => this.onSelectSourceChange()}
                                onError={(err) => this.onFileLoadError(err)} />
                            <div className="page-range-section">
                                <PageRange
                                    disabled={this.state.isPredicting || this.state.isFetching}
                                    withPageRange={this.state.withPageRange}
                                    pageRange={this.state.pageRange}
                                    onPageRangeChange={this.onPageRangeChange} />
                            </div>
                        </div>
                      */
    }
                      
                        <Separator className="separator-right-pane-main">{strings.prebuiltPredict.analysis}</Separator>
                        <div className="editor-page-right-sidebar-test">
                        <div className="p-3" style={{marginTop: "8px"}}>
                            <div className="container-items-end predict-button">
                                <PrimaryButton
                                    theme={getPrimaryWhiteTheme()}
                                    iconProps={{iconName: "ContactCard"}}
                                    text={strings.prebuiltPredict.runAnalysis}
                                    aria-label={!this.state.isPredicting ? strings.prebuiltPredict.inProgress : ""}
                                    allowDisabledFocus
                                    disabled={predictDisabled}
                                    onClick={this.handleClick}
                                />
                            </div>
                            {this.state.isFetching &&
                                <div className="loading-container">
                                    <Spinner
                                        label="Fetching..."
                                        ariaLive="assertive"
                                        labelPosition="right"
                                        size={SpinnerSize.large}
                                    />
                                </div>
                            }
                            {this.state.isPredicting &&
                                <div className="loading-container">
                                    <Spinner
                                        label={strings.prebuiltPredict.inProgress}
                                        ariaLive="assertive"
                                        labelPosition="right"
                                        size={SpinnerSize.large}
                                    />
                                </div>
                            }
                            {Object.keys(predictions).length > 0 &&
                                <PredictResult
                                    predictions={predictions}
                                    analyzeResult={analyzeFullResult}
                                    page={this.state.currentPage}
                                    tags={this.state.tags}
                                    downloadPrefix={this.state.currentPrebuiltType.name}
                                    downloadResultLabel={this.state.fileLabel}
                                    onPredictionClick={this.onPredictionClick}
                                    onPredictionMouseEnter={this.onPredictionMouseEnter}
                                    onPredictionMouseLeave={this.onPredictionMouseLeave}
                                />
                            }
                            {
                                (Object.keys(predictions).length === 0 && this.state.predictionLoaded) &&
                                <div>{strings.prebuiltPredict.noFieldCanBeExtracted}</div>
                            }
                        </div>
                           </div>

                    </div>
              
              
                
                </div>
                <Alert
                    show={this.state.shouldShowAlert}
                    title={this.state.alertTitle}
                    message={this.state.alertMessage}
                    onClose={() => this.setState({
                        shouldShowAlert: false,
                        alertTitle: "",
                        alertMessage: "",
                        predictionLoaded: true,
                    })}
                />
                <PreventLeaving
                    when={this.state.isPredicting}
                    message={"A prediction operation is currently in progress, are you sure you want to leave?"}
                />
            </div>


 
                
                  </SplitPane>
                             
                <Alert
                    show={this.state.showInvalidRegionWarning}
                    title={strings.editorPage.messages.enforceTaggedRegions.title}
                    // tslint:disable-next-line:max-line-length
                    message={strings.editorPage.messages.enforceTaggedRegions.description}
                    onClose={() => this.setState({ showInvalidRegionWarning: false })}
                />
                <Alert
                    show={this.state.isError}
                    title={this.state.errorTitle || "Error"}
                    message={this.state.errorMessage}
                    onClose={() => this.setState({
                        isError: false,
                        errorTitle: undefined,
                        errorMessage: undefined,
                    })}
                />
                <PreventLeaving
                    when={isRunningOCRs || isCanvasRunningOCR}
                    message={"An OCR operation is currently in progress, are you sure you want to leave?"}
                />
                <PreventLeaving
                    when={isCanvasRunningAutoLabeling}
                    message={"An AutoLabeling option is currently in progress, are you sure you want to leave?"} />
           
           <SkipButton skipTo="pageEditor">{strings.common.skipToMainContent}</SkipButton>
                    </BeforeUnloadComponent> 
         
            </div>
       
            <StatusBar>
                                        <StatusBarMetrics project={this.props.project} />
                                    </StatusBar>
                    
            </>
        );
    }

    // call function from child
    private onPageContainerClick = () => {
        // workaround: tagInput will not lost focus with olmap,
        // so we fire the blur event manually here
        //this.tagInputRef.current.triggerNewTagBlur();
    }

    // tslint:disable-next-line:no-empty
    private onPageClick = () => {
    }


    onFileChange(data: {
        file: File,
        fileLabel: string,
        fetchedFileURL: string
    }): void {
      //  debugger;
        this.setState({
            currentPage: 1,
            analyzeResult: null,
            fileChanged: true,
            ...data,
            predictionLoaded: false,
            fileLoaded: false,
        }, () => {
            if (this.imageMap) {
              //  debugger;
                this.imageMap.removeAllFeatures();
            }
        });
    }

    private handleClick_old = () => {
       
        this.setState({predictionLoaded: false, isPredicting: true});
        this.getPrediction()
            .then((result) => {
              //  debugger;
                this.analyzeResults = _.cloneDeep(result);
                this.tableHelper.setAnalyzeResult(result?.analyzeResult);
                const tags = this.getTagsForPredictResults(this.getPredictionsFromAnalyzeResult(result?.analyzeResult));
                this.setState({
                    tags,
                    analyzeResult: result.analyzeResult,
                    predictionLoaded: true,
                    isPredicting: false,
                }, () => {
                    this.drawPredictionResult();
                });
            }).catch((error) => {
                let alertMessage = "";
                if (error.response) {
                    alertMessage = error.response.data;
                } else if (error.errorCode === ErrorCode.PredictWithoutTrainForbidden) {
                    alertMessage = strings.errors.predictWithoutTrainForbidden.message;
                } else if (error.errorCode === ErrorCode.ModelNotFound) {
                    alertMessage = error.message;
                } else {
                    alertMessage = interpolate(strings.errors.endpointConnectionError.message, {endpoint: "form recognizer backend URL"});
                }
                this.setState({
                    shouldShowAlert: true,
                    alertTitle: "Prediction Failed",
                    alertMessage,
                    isPredicting: false,
                });
            });
        if (this.appInsights) {
            this.appInsights.trackEvent({name: "ANALYZE_EVENT"});
        }
    }

    
    private handleClick = () => {
        debugger;
         this.setState({predictionLoaded: false, isPredicting: true});
      //   this.getPrediction()
         this.getPrediction_Invoice()
             .then((result) => {
                 debugger;
                 console.log("form result==>"+JSON.stringify(result));
                 this.analyzeResults = _.cloneDeep(result);
                 this.tableHelper.setAnalyzeResult(result?.analyzeResult);
                 const tags = this.getTagsForPredictResults(this.getPredictionsFromAnalyzeResult(result?.analyzeResult));
                 this.setState({
                     tags,
                     analyzeResult: result.analyzeResult,
                     predictionLoaded: true,
                     isPredicting: false,
                     analyzeFullResult:result,
                 }, () => {
                     this.drawPredictionResult();
                 });
             }).catch((error) => {
                 let alertMessage = "";
                 if (error.response) {
                     alertMessage = error.response.data;
                 } else if (error.errorCode === ErrorCode.PredictWithoutTrainForbidden) {
                     alertMessage = strings.errors.predictWithoutTrainForbidden.message;
                 } else if (error.errorCode === ErrorCode.ModelNotFound) {
                     alertMessage = error.message;
                 } else {
                     alertMessage = interpolate(strings.errors.endpointConnectionError.message, {endpoint: "form recognizer backend URL"});
                 }
                 this.setState({
                     shouldShowAlert: true,
                     alertTitle: "Prediction Failed",
                     alertMessage,
                     isPredicting: false,
                 });
             });
         if (this.appInsights) {
             this.appInsights.trackEvent({name: "ANALYZE_EVENT"});
         }
     }
    
     private async getPrediction_Invoice()
     {
         debugger;
         const headers = {"Content-Type":  "application/pdf", "cache-control": "no-cache"};
         const apiKey =  IAzureFields.key;
         //
          const parts = this.state.selectedAsset.asset.name.split("/");
          const filename=parts[parts.length-1];
         const endpointURL = getPredictionResult_invoice( this.props.project.name,filename);
         return poll(() => ServiceHelper.getWithAutoRetry(endpointURL, {headers}, apiKey as string), 120000, 500);
    
      /*   axios( endpointURL , { method: "GET" ,  headers}).
         then((resp) => {
           
            return resp;
           }
           
         );*/
         //
     }
    private downloadJson = async () => {
debugger;
      this.setState({displayOverlay:true});
        const parts = this.state.selectedAsset.asset.name.split("/");
        const fileName = parts.pop() || parts.pop();
        const nameFile = fileName.replace(/(.*)\.[^.]+$/, "$1");
        const myData = this.state.analyzeResult;
        const json = JSON.stringify(myData);
        const blob = new Blob([json], { type: 'application/json' });
        const href = await URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = href;
        link.download = nameFile + ".json";
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        this.setState({displayOverlay:false});
    }
    
    private getOcrFromAnalyzeResult(analyzeResult: any) {
        return _.get(analyzeResult, "readResults", []);
    }

    
    private createBoundingBoxVectorFeature = (text, boundingBox, imageExtent, ocrExtent) => {
        const coordinates: number[][] = [];

        // extent is int[4] to represent image dimentions: [left, bottom, right, top]
        const imageWidth = imageExtent[2] - imageExtent[0];
        const imageHeight = imageExtent[3] - imageExtent[1];
        const ocrWidth = ocrExtent[2] - ocrExtent[0];
        const ocrHeight = ocrExtent[3] - ocrExtent[1];

        for (let i = 0; i < boundingBox.length; i += 2) {
            coordinates.push([
                Math.round((boundingBox[i] / ocrWidth) * imageWidth),
                Math.round((1 - (boundingBox[i + 1] / ocrHeight)) * imageHeight),
            ]);
        }

        const feature = new Feature({
            geometry: new Polygon([coordinates]),
        });
        const tag = this.state.tags.find((tag) => tag.name.toLocaleLowerCase() === text.toLocaleLowerCase());
        const isHighlighted = (text.toLocaleLowerCase() === this.state.highlightedField?.toLocaleLowerCase());
        feature.setProperties({
            color: _.get(tag, "color", "#333333"),
            fieldName: text,
            isHighlighted,
        });
        return feature;
    }

    
    private drawPredictionResult = (): void => {
       // debugger;
       // this.imageMap.removeAllFeatures();
        const features = [];
       const imageExtent = [0, 0, this.state.imageWidth, this.state.imageHeight];
        //const imageExtent = [0, 0, 10, 15];
        const ocrForCurrentPage: any = this.getOcrFromAnalyzeResult(this.state.analyzeResult)[this.state.currentPage - 1];
        const ocrExtent = [0, 0, ocrForCurrentPage.width, ocrForCurrentPage.height];
        const predictions = this.getPredictionsFromAnalyzeResult(this.state.analyzeResult);

        for (const fieldName of Object.keys(predictions)) {
            const field = predictions[fieldName];
            if (_.get(field, "page", null) === this.state.currentPage) {
                const text = fieldName;
                const boundingbox = _.get(field, "boundingBox", []);
                const feature = this.createBoundingBoxVectorFeature(text, boundingbox, imageExtent, ocrExtent);
                features.push(feature);
            }
        }

        this.setState({
            features:features});
        this.imageMap.addFeatures(features);
        this.tableHelper.drawTables(this.state.currentPage);
    }
    private getPredictionsFromAnalyzeResult(analyzeResult: any) {
        //debugger;
        if (analyzeResult) {
            const predictions = analyzeResult?.documentResults?.map(item => item.fields)
                .reduce((val, item) => Object.assign(val, item), ({})) ?? {};
            const predictionsCopy = Object.assign({}, predictions);
            delete predictionsCopy.ReceiptType;

            const extendPredictionItem = (key, field) => {
                const result = {};
                const updateFieldValueToResult = (item, itemName) => {
                    if (item.valueObject) {
                        Object.keys(item.valueObject).forEach(key => {
                            result[`${itemName}: ${key}`] = item.valueObject[key];
                        });
                        if (item.text) {
                            result[itemName] = item;
                        }
                    }
                    else {
                        result[itemName] = item;
                    }
                }

                if (field.valueArray) {
                    field.valueArray.forEach((item, index) => {
                        const itemName = field.valueArray.length === 1 ? key : `${key} ${index + 1}`;
                        updateFieldValueToResult(item, itemName);
                    });
                }
                else {
                    updateFieldValueToResult(field, key);
                }
                return result;
            };
            let predictionResult = {};
            for (const key in predictionsCopy) {
                if (Object.prototype.hasOwnProperty.call(predictionsCopy, key)) {
                    const item = predictionsCopy[key];
                    if (item) {
                        predictionResult = Object.assign({}, predictionResult, extendPredictionItem(key, item));
                    }
                }
            }
            return predictionResult;
        } else {
            return {};
        }
    }
    private getTagsForPredictResults(predictions) {
      //  debugger;
        const tags: ITag[] = [];
        Object.keys(predictions).forEach((key, index) => {
            tags.push({
                name: key,
                color: this.tagColors[index],
                // use default type
                type: FieldType.String,
                format: FieldFormat.NotSpecified,
            } as ITag);
        });
        this.setState({
            tags,
        });
        return tags;
    }
    private async getPrediction(): Promise<any> {
        
 
        const filepath= this.state.selectedAsset.asset.path;
       

     //  const endpointURL = this.getPredictionEndpointUrl();
        const endpointURL = this.getPredictionEndpointUrl_Chep( this.state.selectedAsset.asset.name);
      //  const apiKey = this.props.prebuiltSettings.apiKey;
debugger;
      const apiKey =  IAzureFields.key;
        //const headers = {"Content-Type": this.state.file ? this.state.file.type : "application/json", "cache-control": "no-cache"};
       // const body = this.state.file ?? {source: this.state.fetchedFileURL};

       //const img_url = "https://picsum.photos/200/300.jpg";
  let result = await fetch(filepath);
  console.log(result);
   
        const headers = {"Content-Type":  "application/pdf", "cache-control": "no-cache"};
        
        
     
const body = await result.blob();

      //  console.log(" model input1==>"+this.state.fetchedFileURL);
      //  console.log(" model input==>"+body);
        let response;
        try {
            response = await ServiceHelper.postWithAutoRetry(
                endpointURL, body, {headers}, apiKey as string);
              //  console.log(" model output==>"+JSON.stringify(response));
        } catch (err) {
            ServiceHelper.handleServiceError({...err, endpoint: endpointURL});
        }

        const operationLocation = response.headers["operation-location"];

        // Make the second REST API call and get the response.
        return poll(() => ServiceHelper.getWithAutoRetry(operationLocation, {headers}, apiKey as string), 120000, 500);
    }
    /*
     private async getPrediction(): Promise<any> {
        
 
        const filepath= this.state.selectedAsset.asset.path;
       

     //  const endpointURL = this.getPredictionEndpointUrl();
        const endpointURL = this.getPredictionEndpointUrl_Chep( this.state.selectedAsset.asset.name);
      //  const apiKey = this.props.prebuiltSettings.apiKey;
debugger;
      const apiKey =  IAzureFields.key;
        //const headers = {"Content-Type": this.state.file ? this.state.file.type : "application/json", "cache-control": "no-cache"};
       // const body = this.state.file ?? {source: this.state.fetchedFileURL};

       //const img_url = "https://picsum.photos/200/300.jpg";
  let result = await fetch(filepath);
  console.log(result);
   
        const headers = {"Content-Type":  "application/pdf", "cache-control": "no-cache"};
        
        
     
const body = await result.blob();

      //  console.log(" model input1==>"+this.state.fetchedFileURL);
      //  console.log(" model input==>"+body);
        let response;
        try {
            response = await ServiceHelper.postWithAutoRetry(
                endpointURL, body, {headers}, apiKey as string);
              //  console.log(" model output==>"+JSON.stringify(response));
        } catch (err) {
            ServiceHelper.handleServiceError({...err, endpoint: endpointURL});
        }

        const operationLocation = response.headers["operation-location"];

        // Make the second REST API call and get the response.
        return poll(() => ServiceHelper.getWithAutoRetry(operationLocation, {headers}, apiKey as string), 120000, 500);
    }
    */

    getPredictionEndpointUrl = (): string => {
       /* let endpointUrl = url.resolve(
            this.props.prebuiltSettings.serviceURI,
            `/formrecognizer/${constants.prebuiltServiceVersion}${this.state.currentPrebuiltType.servicePath}?includeTextDetails=true`
        );*/

        let endpointUrl = url.resolve(
            IAzureFields.endPoint,
            `/formrecognizer/${constants.prebuiltServiceVersion}${this.state.currentPrebuiltType.servicePath}?includeTextDetails=true`
        );


        
        if (this.state.withPageRange && this.state.pageRangeIsValid) {
            endpointUrl += `&pageRange=${this.state.pageRange}`;
        }
        return endpointUrl + (this.state.currentPrebuiltType.useLocale ? `&locale=${this.state.currentLocale}` : "&locale=en-US");
       // return endpointUrl + (this.state.currentPrebuiltType.useLocale ? `&locale=${this.state.currentLocale}` : "");
    }

    
    /** Analyse data from azure */
    private analyseData = async (outPutFormat?: string) => {
        
        this.setState({ analyzeResult: null, analyseDataLoad: true });
        const parts = this.state.selectedAsset.asset.name.split("/");
        const fileName = parts.pop() || parts.pop();
        const projectName = this.props.match.params["projectName"]
        const headers = accessToken();
        const accessTokenBody = accessTokenData();
      // this.cancelToken = axios.CancelToken.source();
        debugger;
        const fileFullName = this.state.selectedAsset.asset.name;
        const fileNameNew =  fileFullName.slice(fileFullName.lastIndexOf("/") + 1, fileFullName.length);
       const URL = this.getPredictionEndpointUrl_Chep(fileNameNew);

        //const URL = documentPredictionEndPoint(projectName, fileName, outPutFormat);
        try {
            const analysedData = await axios(URL, { method: "POST", headers,
             data: {token: accessTokenBody},
               });
            //  debugger;
            if (analysedData) {
                this.setState({ analyseDataLoad: false });
                if (outPutFormat === "transform" && analysedData.data) {
                    this.setState({ analyzeResult: analysedData.data  });
                } else if (outPutFormat === "raw" && analysedData.data) {
                    this.setState({ analyzeResult: analysedData.data   });
              
                    
                    //store this data to use in Transformations
                    const projectId = this.props.match.params["projectId"];
                    const recentProject = this.props.recentProjects.find((project) => project.id === projectId);
            const projectCopy = Object.assign({}, recentProject);
            projectCopy.analyzeResult =  analysedData.data;
           // projectCopy.folderPath = `${projectName}-${userId}/testing`;
          //  await this.props.actions.saveProject(projectCopy, false, false);
           // await this.props.actions.loadProject(projectCopy);

                    //
              
                } else if (analysedData.data.error) {
                    const data2 = analysedData.data.error.substr(analysedData.data.error.indexOf(":") + 1); // "tocirah sneab"
                    const errorJson = JSON.parse(data2);
                    this.setState({ errorMessage: errorJson });
                }
            } else {
                this.setState({ analyseDataLoad: false });
            }

        } catch (err) {
            let response;
          
                        ServiceHelper.handleServiceError(err);
                 
        }
    }
    
    getPredictionEndpointUrl_Chep = (file_name: string): string => {
       /* let endpointUrl = url.resolve(
            this.props.prebuiltSettings.serviceURI,
            `/formrecognizer/${constants.prebuiltServiceVersion}${this.state.currentPrebuiltType.servicePath}?includeTextDetails=true`
        );*/

       return  runAnalysisPrebuiltInvoice(file_name);
/*
        let endpointUrl = url.resolve(
            IAzureFields.endPoint,
            `/formrecognizer/${constants.prebuiltServiceVersion}${this.state.currentPrebuiltType.servicePath}?includeTextDetails=true`
        );


        
        if (this.state.withPageRange && this.state.pageRangeIsValid) {
            endpointUrl += `&pageRange=${this.state.pageRange}`;
        }
        return endpointUrl + (this.state.currentPrebuiltType.useLocale ? `&locale=${this.state.currentLocale}` : "&locale=en-US");
     */
        // return endpointUrl + (this.state.currentPrebuiltType.useLocale ? `&locale=${this.state.currentLocale}` : "");
    }

    /**
     * Called when the asset side bar is resized
     * @param newWidth The new sidebar width
     */
    private onSideBarResize = (newWidth: number) => {
        this.setState({
            thumbnailSize: {
                width: newWidth,
                height: newWidth / (4 / 3),
            },
        });
        this.resizeCanvas()
    }

    /**
     * Called when the asset sidebar has been completed
     */
    private onSideBarResizeComplete = () => {
        const appSettings = {
            ...this.props.appSettings,
            thumbnailSize: this.state.thumbnailSize,
        };

        this.props.applicationActions.saveAppSettings(appSettings);
    }

    /**
     * Called when a tag from footer is clicked
     * @param tag Tag clicked
     */
    private onTagClicked = (tag: ITag): void => {
        this.setState({
            selectedTag: tag.name,
            lockedTags: [],
        }, () => this.canvas.current.applyTag(tag.name));
    }

    /**
     * Open confirm dialog for tag renaming
     */
    private confirmTagRename = (tag: ITag, newTag: ITag, cancelCallback: () => void): void => {
        this.renameCanceled = cancelCallback;
        this.renameTagConfirm.current.open(tag, newTag);
    }

    /**
     * Renames tag in assets and project, and saves files
     * @param tag Tag to be renamed
     * @param newTag Tag with the new name
     */
    private onTagRenamed = async (tag: ITag, newTag: ITag): Promise<void> => {
        this.renameCanceled = null;
        const assetUpdates = await this.props.actions.updateProjectTag(this.props.project, tag, newTag);
        const selectedAsset = assetUpdates.find((am) => am.asset.id === this.state.selectedAsset.asset.id);

        if (selectedAsset) {
            if (selectedAsset) {
                this.setState({ selectedAsset });
            }
        }
    }

    private onTagRenameCanceled = () => {
        if (this.renameCanceled) {
            this.renameCanceled();
            this.renameCanceled = null;
        }
    }

    /**
     * Open Confirm dialog for tag deletion
     */
    private confirmTagDeleted = (tagName: string): void => {
        this.deleteTagConfirm.current.open(tagName);
    }

    /**
     * Open Confirm dialog for document deletion
     */
    private confirmDocumentDeleted = (): void => {
        this.deleteDocumentConfirm.current.open();
    }

    /**
     * Removes tag from assets and projects and saves files
     * @param tagName Name of tag to be deleted
     */
    private onTagDeleted = async (tagName: string): Promise<void> => {
        const assetUpdates = await this.props.actions.deleteProjectTag(this.props.project, tagName);

        const selectedAsset = assetUpdates.find((am) => am.asset.id === this.state.selectedAsset.asset.id);
        if (selectedAsset) {
            this.setState({ selectedAsset });
        }
    }

    private onCtrlTagClicked = (tag: ITag): void => {
        const locked = this.state.lockedTags;
        this.setState({
            selectedTag: tag.name,
            lockedTags: CanvasHelpers.toggleTag(locked, tag.name),
        }, () => this.canvas.current.applyTag(tag.name));
    }

    private getTagFromKeyboardEvent = (event: KeyboardEvent): ITag => {
        const index = tagIndexKeys.indexOf(event.key);
        const tags = this.props.project.tags;
        if (index >= 0 && index < tags.length) {
            return tags[index];
        }
        return null;
    }

    /**
     * Listens for {number key} and calls `onTagClicked` with tag corresponding to that number
     * @param event KeyDown event
     */
    private handleTagHotKey = (event: KeyboardEvent): void => {
        const tag = this.getTagFromKeyboardEvent(event);
        const selection = this.canvas.current.getSelectedRegions();

        if (tag && selection.length) {
            const { format, type, documentCount, name } = tag;
            const tagCategory = this.tagInputRef.current.getTagCategory(tag.type);
            const category = selection[0].category;
            const labels = this.state.selectedAsset.labelData.labels;
            const isTagLabelTypeDrawnRegion = this.tagInputRef.current.labelAssignedDrawnRegion(labels, tag.name);
            const labelAssigned = this.tagInputRef.current.labelAssigned(labels, name);

            if (labelAssigned && ((category === FeatureCategory.DrawnRegion) !== isTagLabelTypeDrawnRegion)) {
                if (isTagLabelTypeDrawnRegion) {
                    toast.warn(interpolate(strings.tags.warnings.notCompatibleWithDrawnRegionTag, { otherCatagory: category }));
                } else if (tagCategory === FeatureCategory.Checkbox) {
                    toast.warn(interpolate(strings.tags.warnings.notCompatibleWithDrawnRegionTag, { otherCatagory: FeatureCategory.Checkbox }));
                } else {
                    toast.warn(interpolate(strings.tags.warnings.notCompatibleWithDrawnRegionTag, { otherCatagory: FeatureCategory.Text }));
                }
                return;
            } else if (tagCategory === category || category === FeatureCategory.DrawnRegion ||
                (documentCount === 0 && type === FieldType.String && format === FieldFormat.NotSpecified)) {
                if (tagCategory === FeatureCategory.Checkbox && labelAssigned) {
                    toast.warn(strings.tags.warnings.checkboxPerTagLimit);
                    return;
                }
                this.onTagClicked(tag);
            } else {
                toast.warn(strings.tags.warnings.notCompatibleTagType, { autoClose: 7000 });
            }
        }
        // do nothing if region was not selected
    }

    /**
     * Returns a value indicating whether the current asset is taggable
     */
    private isTaggableAssetType = (asset: IAsset): boolean => {
        return asset.type !== AssetType.Unknown;
    }

    /**
     * Raised when the selected asset has been changed.
     * This can either be a parent or child asset
     */
    private onAssetMetadataChanged = async (assetMetadata: IAssetMetadata): Promise<void> => {
        // Comment out below code as we allow regions without tags, it would make labeler's work easier.

        const initialState = assetMetadata.asset.state;

        const asset = { ...assetMetadata.asset };

        if (this.isTaggableAssetType(assetMetadata.asset)) {
            assetMetadata.asset.state = _.get(assetMetadata, "labelData.labels.length", 0) > 0 ?
                AssetState.Tagged :
                AssetState.Visited;
        } else if (assetMetadata.asset.state === AssetState.NotVisited) {
            assetMetadata.asset.state = AssetState.Visited;
        }

        // Only update asset metadata if state changes or is different
        if (initialState !== assetMetadata.asset.state || this.state.selectedAsset !== assetMetadata) {
            if (this.state.selectedAsset.labelData && this.state.selectedAsset.labelData.labels &&
                assetMetadata.labelData && assetMetadata.labelData.labels &&
                assetMetadata.labelData.labels.toString() !== this.state.selectedAsset.labelData.labels.toString()) {
                await this.updatedAssetMetadata(assetMetadata);
            }
            await this.props.actions.saveAssetMetadata(this.props.project, assetMetadata);
            if (this.props.project.lastVisitedAssetId === assetMetadata.asset.id) {
                this.setState({ selectedAsset: assetMetadata });
            }
        }

        // Find and update the root asset in the internal state
        // This forces the root assets that are displayed in the sidebar to
        // accurately show their correct state (not-visited, visited or tagged)
        const assets = [...this.state.assets];
        const assetIndex = assets.findIndex((a) => a.id === asset.id);
        if (assetIndex > -1) {
            assets[assetIndex] = {
                ...asset,
            };
        }

        this.setState({ assets, isValid: true });

        // Workaround for if component is unmounted
        if (!this.isUnmount) {
            this.props.appTitleActions.setTitle(`${this.props.project.name} - [ ${asset.name} ]`);
        }
    }

    private onAssetLoaded = (asset: IAsset, contentSource: ContentSource) => {
        const assets = [...this.state.assets];
        const assetIndex = assets.findIndex((item) => item.id === asset.id);
        if (assetIndex > -1) {
            const assets = [...this.state.assets];
            const item = { ...assets[assetIndex] };
            item.cachedImage = (contentSource as HTMLImageElement).src;
            assets[assetIndex] = item;
            this.setState({ assets });
        }
    }

    /**
     * Raised when the asset binary has been painted onto the canvas tools rendering canvas
     */
    private onCanvasRendered = async (canvas: HTMLCanvasElement) => {
        // When active learning auto-detect is enabled
        // run predictions when asset changes
    }

    private onSelectedRegionsChanged = (selectedRegions: IRegion[]) => {
        this.setState({ selectedRegions });
    }

    private onTagsChanged = async (tags) => {
        const project = {
            ...this.props.project,
            tags,
        };
        await this.props.actions.saveProject(project, true, false);
    }

    private onLockedTagsChanged = (lockedTags: string[]) => {
        this.setState({ lockedTags });
    }

    private onBeforeAssetSelected = (): boolean => {
        if (!this.state.isValid) {
            this.setState({ showInvalidRegionWarning: true });
        }

        return this.state.isValid;
    }

    private selectAsset = async (asset: IAsset): Promise<void> => {
        // Nothing to do if we are already on the same asset.
        if (this.state.selectedAsset && this.state.selectedAsset.asset.id === asset.id) {
            return;
        }

   // console.log("asset=>"+JSON.stringify(asset));

        if (!this.state.isValid) {
            this.setState({ showInvalidRegionWarning: true });
            return;
        }
        if (this.state.isCanvasRunningAutoLabeling) {
            return;
        }

        const assetMetadata = await this.props.actions.loadAssetMetadata(this.props.project, asset);

        try {
            if (!assetMetadata.asset.size) {
                const assetProps = await HtmlFileReader.readAssetAttributes(asset);
                assetMetadata.asset.size = { width: assetProps.width, height: assetProps.height };
            }
        } catch (err) {
            console.warn("Error computing asset size");
        }

        this.setState({
            selectedOcrFile: null,
            tableToView: null,
            tableToViewId: null,
            selectedAsset: assetMetadata,
        }, async () => {
            await this.onAssetMetadataChanged(assetMetadata);
            await this.props.actions.saveProject(this.props.project, false, false);
        });

        //call to file change

        const filepath= this.state.selectedAsset.asset.path;
        let result = await fetch(filepath);   
        const body = await result.blob();
       // var fi1 = new File([body], this.state.selectedAsset.asset.name);
        //debugger;
        this.loadImage();
     /*  this.onFileChange({
            file:  fi1,
            fileLabel: this.state.selectedAsset.asset.name,
            fetchedFileURL: ""
        });*/

        //
        this.setState({
            currentPage: 1,
            analyzeResult: null,
            fileChanged: true,            
            predictionLoaded: false,
            fileLoaded: false,
            fileLabel: this.state.selectedAsset.asset.name,
            fetchedFileURL: ""
        }, () => {
            if (this.imageMap) {
                //debugger;
                this.imageMap.removeAllFeatures();
            }
        });

        //
        
    }

    private loadProjectAssets_fr = async (): Promise<void> => {
        //debugger;
        if (this.loadingProjectAssets) {
            return;
        }

        this.loadingProjectAssets = true;

        try {

            // new changes start
            const projectCopy = Object.assign({}, this.props.project);
            projectCopy.folderPath = `${this.props.match.params["projectName"]}-${this.state.userId}/training`;
            await this.props.actions.saveProject(projectCopy, false, false);


            const assets = _(await this.props.actions.loadAssets(this.props.project))
            .uniqBy((asset) => asset.id)
            .value();

                 // new changes end
            
          //  const assets = _(await this.props.actions.loadAssets(this.props.project))
           //     .uniqBy((asset) => asset.id)
            //    .value();


            if (this.state.assets.length === assets.length
                && JSON.stringify(this.state.assets) === JSON.stringify(assets)) {
                this.loadingProjectAssets = false;
                this.setState({ tagsLoaded: true });
                return;
            }

            const lastVisited = assets.find((asset) => asset.id === this.props.project.lastVisitedAssetId);

            this.setState({
                assets,
            }, async () => {
                await this.props.actions.saveProject(this.props.project, false, true);
                this.setState({ tagsLoaded: true });
                if (assets.length > 0) {
                    await this.selectAsset(lastVisited ? lastVisited : assets[0]);
                }
                this.loadingProjectAssets = false;
            });
        } catch (error) {
            throw Error(error);
        }
    }

    
    private loadProjectAssets = async (): Promise<void> => {
        if (this.loadingProjectAssets) {
            return;
        }
        this.loadingProjectAssets = true;
        const projectCopy = await Object.assign({}, this.props.project);
        projectCopy.folderPath = `${this.props.match.params["projectName"]}-${this.state.userId}/training`;
        await this.props.actions.saveProject(projectCopy, false, false);
        const rootAssets: IAsset[] = this.props.loadAnnotateFiles;
        if (this.state.assets.length === rootAssets.length
            && this.state.assets.map((asset) => asset.id).join(",") === rootAssets.map((asset) => asset.id).join(",")
            && this.state.assets.every((o, i) => Object.keys(o).length === Object.keys(rootAssets[i]).length && Object.keys(o).every(k => o[k] === rootAssets[i][k]))) {
            this.loadingProjectAssets = false;
            return;
        }
        const lastVisited = await rootAssets.length > 0 && rootAssets.find((asset) => asset.id === projectCopy.lastVisitedAssetId);
        if (this.props.project.fromModel) {
            localStorage.setItem("filesLengthFromModel", rootAssets.length.toString());
        }
        this.setState({
            assets: rootAssets,
        }, async () => {
            await this.props.actions.updateProjectTagsFromFiles(this.props.project);
            this.setState({ tagsLoaded: true });
            await this.props.actions.saveProject(this.props.project, false, false);
            if (rootAssets.length > 0 ) {
                await this.selectAsset(lastVisited ? lastVisited : rootAssets[0]);
            }
            this.loadingProjectAssets = false;
        });
    }
    private isBusy = (): boolean => {
        return this.state.isRunningOCRs || this.state.isCanvasRunningOCR || this.state.isCanvasRunningAutoLabeling;
    }


/*
    private loadAllOCRs = async () => {
        if (this.state.isRunningOCRs) {
            return;
        }

        const { project } = this.props;
        if (this.state.assets) {
            this.setState({ isRunningOCRs: true });
            try {
                await throttle(
                    constants.maxConcurrentServiceRequests,
                    this.state.assets.filter((asset) => asset.state === AssetState.NotVisited).map((asset) => asset.id),
                    async (assetId) => {
                        // Get the latest version of asset.
                        const asset = await this.state.assets.find((asset) => asset.id === assetId);
                        if (asset && asset.state === AssetState.NotVisited) {
                            try {
                                this.updateAssetState(asset.id, true, false);
                                const parts = asset.name.split("/");
                                const fileName = parts.pop() || parts.pop();
                                await this.props.actions.generateOcrForSingleFile(project, fileName, asset);
                                this.updateAssetState(asset.id, false, false);
                          } catch (err) {
                                this.updateAssetState(asset.id, false, false);
                                this.setState({
                                    isError: true,
                                    errorTitle: err.title,
                                    errorMessage: err.message,
                                });
                            }
                        }
                    });
            } finally {
                this.setState({ isRunningOCRs: false });
            }
        }
    }

*/

    public loadOcrForNotVisited = async (runForAll?: boolean) => {
        if (this.isBusy()) {
            return;
        }
        const { project } = this.props;
        const ocrService = new OCRService(project);
        if (this.state.assets) {
            this.setState({ isRunningOCRs: true });
            try {
                await throttle(
                    constants.maxConcurrentServiceRequests,
                    this.state.assets
                        .filter((asset) => runForAll ? asset : asset.state === AssetState.NotVisited)
                        .map((asset) => asset.id),
                    async (assetId) => {
                        // Get the latest version of asset.
                        const asset = this.state.assets.find((asset) => asset.id === assetId);
                        if (asset && (asset.state === AssetState.NotVisited || runForAll)) {
                            try {
                                this.updateAssetState(asset.id, true);
                                await ocrService.getRecognizedTextFR(asset.path, asset.name, undefined, runForAll);
                                //await ocrService.getRecognizedText(asset.path, asset.name, undefined, runForAll);
                                this.updateAssetState(asset.id, false, AssetState.Visited);
                            } catch (err) {
                                this.updateAssetState(asset.id, false);
                                this.setState({
                                    isError: true,
                                    errorTitle: err.title,
                                    errorMessage: err.message,
                                });
                            }
                        }
                    }
                );
            } finally {
                this.setState({ isRunningOCRs: false });
            }
        }
    }

    private updateAssetState = (id: string, isRunningOCR: boolean, assetState?: AssetState) => {
        this.setState((state) => ({
            assets: state.assets.map((asset) => {
                if (asset.id === id) {
                    const updatedAsset = { ...asset, isRunningOCR };
                    if (assetState !== undefined && asset.state === AssetState.NotVisited) {
                        updatedAsset.state = assetState;
                    }
                    return updatedAsset;
                } else {
                    return asset;
                }
            }),
        }), () => {
            if (this.state.selectedAsset && id === this.state.selectedAsset.asset.id) {
                const asset = this.state.assets.find((asset) => asset.id === id);
                if (asset) {
                    this.setState({
                        selectedAsset: { ...this.state.selectedAsset, asset: { ...asset } },
                    });
                }
            }
        });
    }

    /**
     * Updates the root asset list from the project assets
     */
    private updateAssetsState = () => {
        const updatedAssets = [...this.state.assets];
        let needUpdate = false;
        updatedAssets.forEach((asset) => {
            const projectAsset = _.get(this.props, "project.assets[asset.id]", null);
            if (projectAsset) {
                if (asset.state !== projectAsset.state) {
                    needUpdate = true;
                    asset.state = projectAsset.state;
                }
            }
        });

        if (needUpdate) {
            this.setState({ assets: updatedAssets });
        }
    }

    private onLabelEnter = (label: ILabel) => {
        this.setState({ hoveredLabel: label });
    }

    private onLabelLeave = (label: ILabel) => {
        this.setState({ hoveredLabel: null });
    }

    private onCanvasRunningOCRStatusChanged = (isCanvasRunningOCR: boolean) => {
        this.setState({ isCanvasRunningOCR });
    }
    private onCanvasRunningAutoLabelingStatusChanged = (isCanvasRunningAutoLabeling: boolean) => {
        this.setState({ isCanvasRunningAutoLabeling });
    }
    private onFocused = () => {
        this.loadProjectAssets();
    }

    private onAssetDeleted = () => {
        this.props.actions.deleteAssetFR(this.props.project, this.state.selectedAsset).then(() => {
            this.loadProjectAssets();
        });
    }

    private onTagChanged = async (oldTag: ITag, newTag: ITag) => {
        const assetUpdates = await this.props.actions.updateProjectTag(this.props.project, oldTag, newTag);
        const selectedAsset = assetUpdates.find((am) => am.asset.id === this.state.selectedAsset.asset.id);

        if (selectedAsset) {
            this.setState({
                selectedAsset,
            });
        }
    }

    private setTableToView = async (tableToView, tableToViewId) => {
        if (this.state.tableToViewId) {
            this.canvas.current.setTableState(this.state.tableToViewId, "rest");
        }
        this.canvas.current.setTableState(tableToViewId, "selected");
        this.setState({
            tableToView,
            tableToViewId,
        });
    }

    private handleTableViewClose = () => {
        this.closeTableView("rest");
    }

    private closeTableView = (state: string) => { debugger
        if (this.state.tableToView) {
            // this.canvas.current.setTableState(this.state.tableToViewId, state);
            this.setState({
                tableToView: null,
                tableToViewId: null,
            });
        }
    }

    private resizeCanvas = () => {
        if (this.canvas.current) {
            this.canvas.current.updateSize();
        }
    }

    private async updatedAssetMetadata(assetMetadata: IAssetMetadata) {
        const assetDocumentCountDifference = {};
        const updatedAssetLabels = {};
        const currentAssetLabels = {};
        assetMetadata.labelData.labels.forEach((label) => {
            updatedAssetLabels[label.label] = true;
        });
        this.state.selectedAsset.labelData.labels.forEach((label) => {
            currentAssetLabels[label.label] = true;
        });
        Object.keys(currentAssetLabels).forEach((label) => {
            if (!updatedAssetLabels[label]) {
                assetDocumentCountDifference[label] = -1;
            }
        });
        Object.keys(updatedAssetLabels).forEach((label) => {
            if (!currentAssetLabels[label]) {
                assetDocumentCountDifference[label] = 1;
            }
        });
        await this.props.actions.updatedAssetMetadata(this.props.project, assetDocumentCountDifference);
    }

    private onPredictionMouseEnter = (predictedItem: any) => {
        this.setState({
            highlightedField: predictedItem.fieldName ?? "",
        });
    }

    private onPredictionMouseLeave = (predictedItem: any) => {
        this.setState({
            highlightedField: "",
        });
    }

    private onPredictionClick = (predictedItem: any) => {
        const targetPage = predictedItem.page;
        if (Number.isInteger(targetPage) && targetPage !== this.state.currentPage) {
            this.setState({
                currentPage: targetPage,
                highlightedField: predictedItem.fieldName ?? "",
            });
        }
    }

    
    private renderImageMap = () => {
        const hostStyles: Partial<ITooltipHostStyles> = {
            root: {
                position: "absolute",
                top: this.state.tableIconTooltip.top,
                left: this.state.tableIconTooltip.left,
                width: this.state.tableIconTooltip.width,
                height: this.state.tableIconTooltip.height,
                display: this.state.tableIconTooltip.display,
            },
        };
        return (
            <div style={{width: "100%", height: "100%"}}>
                <CanvasCommandBar
                    handleZoomIn={this.handleCanvasZoomIn}
                    handleZoomOut={this.handleCanvasZoomOut}
                    handleRotateImage={this.handleRotateCanvas}
                    layers={{}}
                />
                <ImageMap
                    initEditorMap={true}
                    ref={(ref) => {
                        this.imageMap = ref;
                        this.tableHelper.setImageMap(ref);
                    }}
                    imageUri={this.state.imageUri || ""}
                    imageWidth={this.state.imageWidth}
                    imageHeight={this.state.imageHeight}
                    imageAngle={this.state.imageAngle}
                    featureStyler={this.featureStyler}
                    onMapReady={this.noOp}
                    tableBorderFeatureStyler={this.tableHelper.tableBorderFeatureStyler}
                    tableIconFeatureStyler={this.tableHelper.tableIconFeatureStyler}
                    tableIconBorderFeatureStyler={this.tableHelper.tableIconBorderFeatureStyler}
                    handleTableToolTipChange={this.tableHelper.handleTableToolTipChange}
                />
                <TooltipHost
                    content={"rows: " + this.state.tableIconTooltip.rows +
                        " columns: " + this.state.tableIconTooltip.columns}
                    id="tableInfo"
                    styles={hostStyles}
                >
                    <div
                        aria-describedby="tableInfo"
                        className="tooltip-container"
                        onClick={this.handleTableIconFeatureSelect}
                    />
                </TooltipHost>
                {this.state.tableToView !== null &&
                    <TableView
                        handleTableViewClose={this.handleTableViewClose}
                        tableToView={this.state.tableToView}
                    />
                }
            </div>
        );
    }

    private handleTableIconFeatureSelect = () => { debugger
        if (this.state.hoveringFeature != null) {
            const tableState = this.imageMap.getTableBorderFeatureByID(this.state.hoveringFeature).get("state");
            if (tableState === "hovering" || tableState === "rest" || tableState === "selected"  ) {
                this.tableHelper.setTableToView(this.tableHelper.getTable(this.state.currentPage, this.state.hoveringFeature),
                    this.state.hoveringFeature);
            } else {
                this.closeTableView("hovering");
            }
        }
    }

    private noOp = () => {
        // no operation
    }

    private featureStyler = (feature) => {
        return new Style({
            stroke: new Stroke({
                color: feature.get("color"),
                width: feature.get("isHighlighted") ? 4 : 2,
            }),
            fill: new Fill({
                color: "rgba(255, 255, 255, 0)",
            }),
        });
    }

    private handleCanvasZoomIn = () => {
        this.imageMap.zoomIn();
    }

    private handleCanvasZoomOut = () => {
        this.imageMap.zoomOut();
    }
    

    private handleRotateCanvas = (degrees: number) => {
        this.setState({imageAngle: this.state.imageAngle + degrees});
    }

    
    private prevPage = () => {
        this.setState((prevState) => ({
            currentPage: Math.max(1, prevState.currentPage - 1),
        }), () => {
            this.imageMap?.removeAllFeatures();
        });
    };
    private nextPage = () => {
        const {numPages} = this.state;
        this.setState((prevState) => ({
            currentPage: Math.min(prevState.currentPage + 1, numPages),
        }), () => {
            this.imageMap?.removeAllFeatures();
        });
    };
    private renderPrevPageButton = () => {
        return this.state.currentPage > 1 ?
            <IconButton
                className="toolbar-btn prev"
                title="Previous"
                iconProps={{iconName: "ChevronLeft"}}
                onClick={this.prevPage}
            /> : <div></div>;
    }

    private renderNextPageButton = () => {
        return this.state.currentPage < this.state.numPages ?
            <IconButton
                className="toolbar-btn next"
                title="Next"
                onClick={this.nextPage}
                iconProps={{iconName: "ChevronRight"}}
            /> : <div></div>;
    }

    private renderPageIndicator = () => {
        const {numPages} = this.state;
        return numPages > 1 ?
            <p className="page-number">
                Page {this.state.currentPage} of {numPages}
            </p> : <div></div>;
    }

    private loadImage = async () => {
        //const asset = this.state.currentAsset.asset;
        const asset = this.state.selectedAsset.asset;
        
        if (asset.type === AssetType.Image) {
            const canvas = await loadImageToCanvas(asset.path);
            this.setState({
                imageUri: canvas.toDataURL(constants.convertedImageFormat, constants.convertedImageQuality),
                imageWidth: canvas.width,
                imageHeight: canvas.height,
            });
        } else if (asset.type === AssetType.TIFF) {
            await this.loadTiffFile(asset);
        } else if (asset.type === AssetType.PDF) {
            await this.loadPdfFile(asset.id, asset.path);
        }
    }
   

    private loadTiffFile = async (asset: IAsset) => {
        const assetArrayBuffer = await HtmlFileReader.getAssetArray(asset);
        const tiffImages = parseTiffData(assetArrayBuffer);
        this.loadTiffPage(tiffImages, this.state.currentPage);
    }

    private loadTiffPage = (tiffImages: any[], pageNumber: number) => {
        const tiffImage = tiffImages[pageNumber - 1];
        const canvas = renderTiffToCanvas(tiffImage);
        this.setState({
            imageUri: canvas.toDataURL(constants.convertedImageFormat, constants.convertedImageQuality),
            imageWidth: tiffImage.width,
            imageHeight: tiffImage.height,
            numPages: tiffImages.length,
            currentPage: pageNumber,
            tiffImages,
        });
    }

    private loadPdfFile = async (assetId, url) => {
        try {
            const pdf = await pdfjsLib.getDocument({url, cMapUrl, cMapPacked: true}).promise;
            // Fetch current page
            if (assetId === this.state.selectedAsset.asset.id) {
                await this.loadPdfPage(assetId, pdf, this.state.currentPage);
            }
        } catch (reason) {
            // PDF loading error
            console.error(reason);
        }
    }

    private loadPdfPage = async (assetId, pdf, pageNumber) => {
        const page = await pdf.getPage(pageNumber);
        const defaultScale = 2;
        const viewport = page.getViewport({ scale: defaultScale });

        // Prepare canvas using PDF page dimensions
        const canvas = document.createElement("canvas");
        const context = canvas.getContext("2d");
        canvas.height = viewport.height;
        canvas.width = viewport.width;

        // Render PDF page into canvas context
        const renderContext = {
            canvasContext: context,
            viewport,
        };

        await page.render(renderContext).promise;
        if (assetId === this.state.selectedAsset.asset.id) {
            this.setState({
                imageUri: canvas.toDataURL(constants.convertedImageFormat, constants.convertedImageQuality),
                imageWidth: canvas.width,
                imageHeight: canvas.height,
                numPages: pdf.numPages,
                currentPage: pageNumber,
                pdfFile: pdf,
            });
        }
    }

    private setPredictedFieldHighlightStatus = (highlightedField: string) => {
        const features = this.imageMap.getAllFeatures();
        for (const feature of features) {
            if (feature.get("fieldName").toLocaleLowerCase() === highlightedField.toLocaleLowerCase()) {
                feature.set("isHighlighted", true);
            } else {
                feature.set("isHighlighted", false);
            }
        }
    }

}
